import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f5dbba78")
const _hoisted_1 = { class: "thread p-ripple" }
const _hoisted_2 = { class: "thread__data" }
const _hoisted_3 = { class: "thread__badge" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = { class: "thread__name" }
const _hoisted_6 = { class: "business_name" }
const _hoisted_7 = { class: "user_name" }
const _hoisted_8 = { class: "thread__date" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatAvatar = _resolveComponent("ChatAvatar")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_component_ChatAvatar, { username: _ctx.userName }, null, 8, ["username"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.hasToRead)
          ? (_openBlock(), _createBlock(_component_Badge, {
              key: 0,
              class: "small_badge p-badge-danger"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.businessName), 1),
        _createElementVNode("small", _hoisted_7, _toDisplayString(_ctx.userName), 1)
      ]),
      _createElementVNode("small", _hoisted_8, [
        _createVNode(_component_DateFormatted, {
          date: _ctx.thread.last_message_at,
          format: "DD/MM/YYYY HH:mm"
        }, null, 8, ["date"])
      ])
    ])
  ], 512)), [
    [_directive_ripple]
  ])
}